module.exports = __webpack_public_path__ + "6478c469b3fff4a9c8412b14bfb5746e.png";